import { Component, OnInit } from '@angular/core';
import { MainAnalyticsService } from '@profile/services/main_analytics.service';
import { HandlerService } from '@app/_services/handler.service';
import { Router } from '@angular/router';
import 'rxjs/add/operator/pairwise';

@Component({
    selector: 'app-profile-results',
    templateUrl: './profile-results.component.html',
    styleUrls: ['./profile-results.component.scss']
})
export class ProfileResultsComponent implements OnInit {
    currentLesson: any;
    currentLessonIndex = 0;
    lessons: any;
    isActivePrevNav: boolean = true;
    isActiveNextNav: boolean = false;

    constructor(
        private mainAnalyticsService: MainAnalyticsService,
        private handlerService: HandlerService,
        private router: Router
    ) {}

    ngOnInit() {
        this.getSimpleLessonsInfo();
    }

    private changeUrl(): void {
        const lessonId = this.lessons[this.currentLessonIndex].id;
        const newUrl = this.router.url.replace(/(\d+)/g, lessonId);
        this.router.navigate([newUrl]).then();
    }

    private getSimpleLessonsInfo(): void {
        const lessonId = +this.router.url.replace(/[^0-9]/g, '');

        this.mainAnalyticsService.getSimpleLessonsInfo().subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (!resp.errors.length) {
                this.lessons = resp.data.lessons;
                const lessonsId = this.lessons.map(it => it.id);
                localStorage.setItem('LESSONS_IDs', JSON.stringify(lessonsId));

                if (!lessonId && this.lessons.length) {
                    this.currentLesson = this.lessons[0];
                    this.isActiveNextNav = false;
                    const newUrl = this.router.url.replace(/(\d+)/g, this.currentLesson.id);
                    this.router.navigate([newUrl]).then();
                    return;
                }

                if (this.lessons[0].id === lessonId) {
                    this.currentLesson = this.lessons[0];
                    return;
                }

                this.currentLessonIndex = this.lessons.findIndex(it => it.id === lessonId);
                this.currentLesson = this.lessons[this.currentLessonIndex];
                this.isActivePrevNav = true;
                this.isActiveNextNav = true;
                const newUrl = this.router.url.replace(/(\d+)/g, this.currentLesson.id);
                this.router.navigate([newUrl]).then();

                if (this.currentLesson.lesson_number === 1) {
                    this.isActivePrevNav = false;
                }
            }
        });
    }

    nextLesson(): void {
        if (this.currentLessonIndex) {
            this.isActivePrevNav = true;
            this.currentLessonIndex -= 1;
            this.changeUrl();
            this.currentLesson = this.lessons[this.currentLessonIndex];

            if (!this.currentLessonIndex) {
                this.isActiveNextNav = false;
            }
            return;
        }
    }

    prevLesson(): void {
        const maxIndex = this.lessons.length - 1;
        if (this.currentLessonIndex < maxIndex) {
            this.isActiveNextNav = true;
            this.currentLessonIndex += 1;
            this.changeUrl();
            this.currentLesson = this.lessons[this.currentLessonIndex];

            if (this.currentLessonIndex === maxIndex) {
                this.isActivePrevNav = false;
            }
            return;
        }
    }
}
